export const GET_DISCOUNT = '/get_discount';
export const GET_SINGLE_DISCOUNT = '/get_single_discount';
export const UPDATE_DISCOUNT = '/update_discount';
export const CREATE_DISCOUNT = '/create_discount';
export const REMOVE_DISCOUNT = '/remove_discount';
export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';

export const FORM_DATA = {
  name: '',
  description: '',
  discount: '',
  actual_use_id: '',
  effective_date_from: '',
  // effective_date_to: '',
  discount_from: '',
  discount_to: '',
};